"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var BaseView_1 = require("@shared/views/BaseView");
var models_1 = require("@shared/models");
var DeckFilterMenu = /** @class */ (function (_super) {
    __extends(DeckFilterMenu, _super);
    function DeckFilterMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.searchRequest = new models_1.DeckSearchRequest();
        _this.visible = false;
        _this.companyProxy = '';
        _this.recommendedCompanies = [];
        _this.companiesLoading = false;
        _this.techProxy = '';
        _this.recommendedTechnologies = [];
        _this.technologiesLoading = false;
        _this.proProxy = '';
        _this.recommendedPros = [];
        _this.prosLoading = false;
        _this.artistProxy = '';
        _this.artistsLoading = false;
        _this.recommendedArtists = [];
        _this.seriesProxy = '';
        _this.recommendedSeries = [];
        _this.seriesLoading = false;
        _this.categoryProxy = '';
        _this.recommendedCategories = [];
        _this.categoriesLoading = false;
        _this.sortColumnOptions = [
            { text: 'Year', value: 'year' },
            { text: 'Name', value: 'name' },
            { text: 'Season', value: 'season' },
            { text: 'Created Date', value: 'createddate' },
            { text: 'Last Updated', value: null },
        ];
        _this.sortDirectionOptions = [
            { text: 'Asc', value: 'asc' },
            { text: 'Desc', value: 'desc' },
        ];
        _this.activeOptions = [{ text: 'All', value: null }, { text: 'Inactive', value: false }, { text: 'Active', value: true }];
        _this.pageSizeOptions = [
            { text: '60', value: 60 },
            { text: '120', value: 120 },
            { text: '240', value: 240 },
        ];
        return _this;
    }
    /** Fires when the company select list is changed. Searches companies to display in the list */
    DeckFilterMenu.prototype.searchCompanies = function (criteria) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, 3, 4]);
                        this.companiesLoading = true;
                        if (!criteria) {
                            return [2 /*return*/];
                        }
                        _a = this;
                        return [4 /*yield*/, this.$api.companyService.autocomplete(criteria)];
                    case 1:
                        _a.recommendedCompanies = _b.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        err_1 = _b.sent();
                        this.errorHandler.handle(err_1, 'An error occurred while loading recommended companies');
                        return [3 /*break*/, 4];
                    case 3:
                        this.companiesLoading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /** Fires when the artist select list is changed. Searches artists to display in the list */
    DeckFilterMenu.prototype.searchArtists = function (criteria) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, err_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, 3, 4]);
                        this.artistsLoading = true;
                        if (!criteria) {
                            return [2 /*return*/];
                        }
                        _a = this;
                        return [4 /*yield*/, this.$api.artistService.autocomplete(criteria)];
                    case 1:
                        _a.recommendedArtists = _b.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        err_2 = _b.sent();
                        this.errorHandler.handle(err_2, 'An error occurred while loading recommended artists');
                        return [3 /*break*/, 4];
                    case 3:
                        this.artistsLoading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /** Fires when the pro select list is changed. Searches pros to display in the list */
    DeckFilterMenu.prototype.searchPros = function (criteria) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, err_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, 3, 4]);
                        this.prosLoading = true;
                        if (!criteria) {
                            return [2 /*return*/];
                        }
                        _a = this;
                        return [4 /*yield*/, this.$api.proService.autocomplete(criteria)];
                    case 1:
                        _a.recommendedPros = _b.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        err_3 = _b.sent();
                        this.errorHandler.handle(err_3, 'An error occurred while loading recommended pros');
                        return [3 /*break*/, 4];
                    case 3:
                        this.prosLoading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /** Fires when the series select list is changed. Searches series to display in the list */
    DeckFilterMenu.prototype.searchSeries = function (criteria) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, err_4;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, 3, 4]);
                        this.seriesLoading = true;
                        if (!criteria) {
                            return [2 /*return*/];
                        }
                        _a = this;
                        return [4 /*yield*/, this.$api.seriesService.autocomplete(criteria)];
                    case 1:
                        _a.recommendedSeries = _b.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        err_4 = _b.sent();
                        this.errorHandler.handle(err_4, 'An error occurred while loading recommended series');
                        return [3 /*break*/, 4];
                    case 3:
                        this.seriesLoading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /** Fires when the categories select list is changed. Searches categories to display in the list */
    DeckFilterMenu.prototype.searchCategories = function (criteria) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, err_5;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, 3, 4]);
                        this.categoriesLoading = true;
                        if (!criteria) {
                            return [2 /*return*/];
                        }
                        _a = this;
                        return [4 /*yield*/, this.$api.categoryService.autocomplete(criteria)];
                    case 1:
                        _a.recommendedCategories = _b.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        err_5 = _b.sent();
                        this.errorHandler.handle(err_5, 'An error occurred while loading recommended categories');
                        return [3 /*break*/, 4];
                    case 3:
                        this.categoriesLoading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /** Fires when the technologies select list is changed. Searches technologies to display in the list */
    DeckFilterMenu.prototype.searchTechnologies = function (criteria) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, err_6;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, 3, 4]);
                        this.technologiesLoading = true;
                        if (!criteria) {
                            return [2 /*return*/];
                        }
                        _a = this;
                        return [4 /*yield*/, this.$api.technologyService.autocomplete(criteria)];
                    case 1:
                        _a.recommendedTechnologies = _b.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        err_6 = _b.sent();
                        this.errorHandler.handle(err_6, 'An error occurred while loading recommended technologies');
                        return [3 /*break*/, 4];
                    case 3:
                        this.technologiesLoading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /** Applies the specified filter and redirects to the new page with the correct query parameters */
    DeckFilterMenu.prototype.filter = function (resetPage) {
        this.scroll.scrollToTop();
        if (resetPage) {
            this.searchRequest.pageIndex = 0;
        }
        this.searchRequest.companyIds = this.searchRequest.companies.map(function (x) { return x.id; });
        this.searchRequest.technologyIds = this.searchRequest.technologies.map(function (x) { return x.id; });
        this.searchRequest.artistIds = this.searchRequest.artists.map(function (x) { return x.id; });
        this.searchRequest.proIds = this.searchRequest.pros.map(function (x) { return x.id; });
        this.searchRequest.categoryIds = this.searchRequest.categories.map(function (x) { return parseInt(x.id.toString(), null); });
        // this.analytics.event('Decks', 'click', 'Filter Applied');
        // STORE SELECTED FILTERS IN LOCAL STORAGE
        this.storage.store('deck-filter', this.searchRequest);
        this.$router.push({ name: 'deck-list', query: this.searchRequest.collapse() }).catch(function () { });
    };
    /** Clears the filter that applied to the result set */
    DeckFilterMenu.prototype.clear = function () {
        this.visible = false;
        this.storage.remove('deck-filter');
        this.$router.push('/decks/browse').catch(function () { });
        // this.analytics.event('Decks', 'click', 'Filter Cleared');
    };
    /** Shows this menu. */
    DeckFilterMenu.prototype.show = function (searchRequest) {
        this.searchRequest = new models_1.DeckSearchRequest(searchRequest);
        this.recommendedArtists = this.searchRequest.artists;
        this.recommendedSeries = this.searchRequest.series;
        this.recommendedCategories = this.searchRequest.categories;
        this.recommendedCompanies = this.searchRequest.companies;
        this.recommendedTechnologies = this.searchRequest.technologies;
        this.recommendedPros = this.searchRequest.pros;
        this.visible = true;
        var that = this;
        setTimeout(function () { return that.$refs.criteriaField.focus(); }, this.settings.focusTimeout);
        // this.analytics.event('Decks', 'click', 'Filter Menu Opened');
    };
    /** Hides this menu  */
    DeckFilterMenu.prototype.hide = function () {
        this.visible = false;
    };
    __decorate([
        vue_property_decorator_1.Watch('companyProxy')
    ], DeckFilterMenu.prototype, "searchCompanies", null);
    __decorate([
        vue_property_decorator_1.Watch('artistProxy')
    ], DeckFilterMenu.prototype, "searchArtists", null);
    __decorate([
        vue_property_decorator_1.Watch('proProxy')
    ], DeckFilterMenu.prototype, "searchPros", null);
    __decorate([
        vue_property_decorator_1.Watch('seriesProxy')
    ], DeckFilterMenu.prototype, "searchSeries", null);
    __decorate([
        vue_property_decorator_1.Watch('categoryProxy')
    ], DeckFilterMenu.prototype, "searchCategories", null);
    __decorate([
        vue_property_decorator_1.Watch('techProxy')
    ], DeckFilterMenu.prototype, "searchTechnologies", null);
    DeckFilterMenu = __decorate([
        vue_property_decorator_1.Component({})
    ], DeckFilterMenu);
    return DeckFilterMenu;
}(BaseView_1.BaseView));
exports.default = DeckFilterMenu;
